// src/components/About.js
import React from 'react';

const About = () => {
  return (
    <section className="section about">
      <h2>About Me</h2>
      <p>
        Hi! I'm <strong>Aniket Srivastava</strong>, a dedicated and detail-oriented Computer Science graduate with hands-on experience in manual software testing and full-stack development. I am passionate about building efficient, user-friendly applications and have a strong foundation in Python, JavaScript, and modern web frameworks.
      </p>
      <p>
        Currently working as a Manual Tester at <strong>QualityKiosk Technologies Pvt. Ltd.</strong>, I’m deeply involved in functional, system, and unit testing of enterprise applications. I enjoy taking on challenging problems and contributing to high-quality software delivery.
      </p>
      <p>
        I'm always eager to learn new technologies, improve my skills, and collaborate with passionate teams to create impactful digital experiences.
      </p>
      
      {/* Resume Download Link */}
      <a
        href="/ANIKET_SRIVASTAVA_RESUME.pdf"
        download="ANIKET_SRIVASTAVA_RESUME.pdf"
        className="download-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        Download Resume
      </a>
    </section>
  );
};

export default About;
